// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Vhvb","bigColWidth":"Table_bigColWidth__34g-j","biggerColWidth":"Table_biggerColWidth__1J78Y","row":"Table_row__tK92I","col":"Table_col__2rZlg"};